import React from 'react';
import {AttentionMessageProps} from './index';
import OrderStatusExpired from './OrderStatusExpired';
import {MessageComponentType} from './ControlledOrderAttentionMessage';
import {IOrderAttentionModel} from '../../../../../src/@interfaces/models/Order/IOrderAttentionModel';
import Translate from '../../../../../src/components/Translate/Translate';

function Message(props: MessageComponentType) {
    const model: IOrderAttentionModel<'order-product-deadline-expired'> = props.model as any;

    return <Translate message={props.message} replace={{id: String(model.details?.product_id)}}/>;
}

OrderProductDeadlineExpired.getMessageComponent = () => Message;

export default function OrderProductDeadlineExpired(props: AttentionMessageProps) {
    return <OrderStatusExpired {...props}/>;
}
